// extracted by mini-css-extract-plugin
module.exports = {"inclusions":"EntryRequirementsSegments_inclusions__PPyA1","subheading":"EntryRequirementsSegments_subheading__Akw5f","spinner":"EntryRequirementsSegments_spinner__efbRV"};